





























































































































































































































































import { VueEditor } from "vue2-editor";
import EditorMixins from "@/mixins/EditorMixins";
import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  HCS_TYPES,
  HCS_RECOMMENDATION_TYPE_STANDARD,
  HCS_RECOMMENDATION_TYPE_SPECIAL,
  HCS_RECOMMENDATION_TYPES
} from "@/store/modules/ModuleQuestionGroup";
import _ from "lodash";
import { TYPES, TYPE_OPTIONS } from "../../../../constants/risk_profile";

@Component({
  components: {
    VueEditor
  },
  computed: {
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup"
    })
  }
})
export default class QuestionGroupFormFields extends Mixins(EditorMixins) {
  questionGroup!: QuestionGroupState["questionGroup"];

  operators = [">=", ">", "<=", "<", "==", "<>"];

  riskProfileTypes = TYPES;
  riskProfileTypeOptions = TYPE_OPTIONS;
  hcsTypes = HCS_TYPES;
  hcsRecommendationTypes = HCS_RECOMMENDATION_TYPES;
  overallScorePreview = "0";
  recommendationRule = [v => !v || v?.length <= 180 || "Max 180 characters"];
  specialWordingRule = [v => !v || v?.length <= 255 || "Max 255 characters"];

  get isRecommendationStandard() {
    return (
      this.questionGroup.hcs_recommendation_type ===
      HCS_RECOMMENDATION_TYPE_STANDARD
    );
  }

  get isRecommendationSpecial() {
    return (
      this.questionGroup.hcs_recommendation_type ===
      HCS_RECOMMENDATION_TYPE_SPECIAL
    );
  }

  get getPreviewSize() {
    return this.isRecommendationStandard ? 4 : 6;
  }

  get getRecommendation() {
    return this.isRecommendationStandard
      ? this.questionGroup.hcs_recommendation
      : this.getSpecialWordingDisplay;
  }

  get getSpecialWordingDisplay() {
    if (!this.overallScorePreview) {
      return null;
    }
    return this.questionGroup.hcs_special_wording_display?.find(item => {
      if (!item.value) {
        return null;
      }
      if (item.operator == "<>") {
        const [from, to] = item.value.split(",").map(v => Number(v));
        if (isNaN(from) || isNaN(to)) {
          return null;
        }
        return _.range(from, to).includes(Number(this.overallScorePreview))
          ? item
          : null;
      }
      if (isNaN(Number(item.value))) {
        return null;
      }
      return eval(`${this.overallScorePreview} ${item.operator} ${item.value} `)
        ? item
        : null;
    })?.recommendation;
  }

  addSpecialWordingDisplay() {
    this.$store.commit("QuestionGroup/ADD_HSC_SPECIAL_WORDING_DISPLAY");
  }

  removeSpecialWordingDisplay(index) {
    this.$store.commit(
      "QuestionGroup/REMOVE_HSC_SPECIAL_WORDING_DISPLAY",
      index
    );
  }

  onHCSRecommendationTypeChange() {
    if (!this.questionGroup.hcs_special_wording_display) {
      this.questionGroup.hcs_special_wording_display = [];
    }
    if (
      this.isRecommendationSpecial &&
      this.questionGroup.hcs_special_wording_display.length === 0
    ) {
      this.$store.commit("QuestionGroup/ADD_HSC_SPECIAL_WORDING_DISPLAY");
    }
  }
}
